import { useControl } from "../hooks";
import type { BaseFormProps } from "../types";
import type { PhoneInputProps } from "./PhoneInput";
import { PhoneInput } from "./PhoneInput";

export type FormPhoneInputProps = Omit<PhoneInputProps, "value" | "onChange"> & Omit<BaseFormProps, "error">;

export const FormPhoneInput = (props: FormPhoneInputProps) => {
	const { error, field } = useControl({ name: props.name });
	return <PhoneInput {...props} error={error} {...field} />;
};
